import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";
import { PropsWithChildren, Suspense } from "react";

export default function SuspenseWrapperWithLoader({
  children,
}: PropsWithChildren<unknown>) {
  return <Suspense fallback={<LoadingIndicator />}>{children}</Suspense>;
}
